var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065ZM8.00016 4.83398C8.2763 4.83398 8.50016 5.05784 8.50016 5.33398V7.50065H10.6668C10.943 7.50065 11.1668 7.72451 11.1668 8.00065C11.1668 8.27679 10.943 8.50065 10.6668 8.50065H8.50016V10.6673C8.50016 10.9435 8.2763 11.1673 8.00016 11.1673C7.72402 11.1673 7.50016 10.9435 7.50016 10.6673V8.50065H5.3335C5.05735 8.50065 4.8335 8.27679 4.8335 8.00065C4.8335 7.72451 5.05735 7.50065 5.3335 7.50065H7.50016V5.33398C7.50016 5.05784 7.72402 4.83398 8.00016 4.83398Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAddIcon);
export default __webpack_public_path__ + "static/media/circleAddIcon.03450f9679061330cfef73283ad35c2e.svg";
export { ForwardRef as ReactComponent };